// Real veteran resources with triage tier eligibility
// Tiers: green (HON/GEN), yellow (OTH/Entry Level), blue (BCD/Dishonorable/Dismissal)
export const benefitsData = [
  {
    id: '1',
    name: 'Swords to Plowshares Legal Services',
    organization: 'Swords to Plowshares',
    description: 'Free legal assistance for veterans seeking discharge upgrades and access to VA benefits. Specializes in OTH discharge cases.',
    categories: ['legal'],
    eligibility: 'All veterans with less-than-honorable discharges',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.swords-to-plowshares.org/veterans-legal-services/',
    phone: '(415) 252-4788',
    verified: true
  },
  {
    id: '2',
    name: 'Veterans Legal Institute',
    organization: 'VLI',
    description: 'National network providing free legal representation for discharge upgrade applications.',
    categories: ['legal'],
    eligibility: 'Veterans with OTH, general, or bad conduct discharges',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.vetslegalinstitute.org/',
    phone: null,
    verified: true
  },
  {
    id: '3',
    name: 'Hire Heroes USA',
    organization: 'Hire Heroes USA',
    description: 'Free career coaching, resume writing, and job placement services for veterans. Works with second-chance employers.',
    categories: ['employment'],
    eligibility: 'All transitioning military members and veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.hireheroesusa.org/',
    phone: '(866) 915-4376',
    verified: true
  },
  {
    id: '4',
    name: 'The Salvation Army Veterans Services',
    organization: 'The Salvation Army',
    description: 'Emergency housing assistance, transitional housing, and permanent supportive housing for veterans experiencing homelessness.',
    categories: ['housing'],
    eligibility: 'All veterans regardless of discharge status',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.salvationarmyusa.org/usn/combat-homelessness/',
    phone: '1-800-SAL-ARMY',
    verified: true
  },
  {
    id: '5',
    name: 'Give an Hour',
    organization: 'Give an Hour',
    description: 'Free mental health services from licensed professionals. Over 7,000 providers nationwide for veterans and families.',
    categories: ['mental-health'],
    eligibility: 'All veterans and military families',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://giveanhour.org/',
    phone: null,
    verified: true
  },
  {
    id: '6',
    name: 'Cohen Veterans Network',
    organization: 'Cohen Veterans Network',
    description: 'Network of mental health clinics providing accessible care for post-9/11 veterans and military families at no cost.',
    categories: ['mental-health'],
    eligibility: 'Post-9/11 veterans and military families',
    tiers: ['green', 'yellow'],
    url: 'https://www.cohenveteransnetwork.org/',
    phone: null,
    verified: true
  },
  {
    id: '7',
    name: 'VetJobs',
    organization: 'VetJobs.com',
    description: 'Job board specifically for veterans with thousands of listings from veteran-friendly employers.',
    categories: ['employment'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.vetjobs.com/',
    phone: null,
    verified: false
  },
  {
    id: '8',
    name: "America's Warrior Partnership",
    organization: "America's Warrior Partnership",
    description: 'Connects veterans to local resources including employment, housing, healthcare, and legal services.',
    categories: ['employment', 'housing', 'healthcare'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.americaswarriorpartnership.org/',
    phone: null,
    verified: true
  },
  {
    id: '9',
    name: 'Operation Homefront Critical Financial Assistance',
    organization: 'Operation Homefront',
    description: 'Emergency financial assistance grants for housing, utilities, food, and other critical needs.',
    categories: ['housing'],
    eligibility: 'All veterans in financial crisis',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.operationhomefront.org/critical-financial-assistance/',
    phone: '(210) 659-7756',
    verified: true
  },
  {
    id: '10',
    name: 'Veterans Upward Bound',
    organization: 'U.S. Department of Education',
    description: 'Free college preparatory program helping veterans complete high school or GED and prepare for post-secondary education.',
    categories: ['education'],
    eligibility: 'Veterans who need assistance preparing for college',
    tiers: ['green', 'yellow'],
    url: 'https://www2.ed.gov/programs/trioupbound/index.html',
    phone: null,
    verified: true
  },
  {
    id: '11',
    name: 'Troops to Teachers',
    organization: 'DANTES',
    description: 'Helps veterans transition to a new career in teaching. Provides counseling, referral, and placement assistance.',
    categories: ['employment', 'education'],
    eligibility: "Veterans with bachelor's degree",
    tiers: ['green'],
    url: 'https://proudtoserveagain.com/',
    phone: '(800) 231-6242',
    verified: true
  },
  {
    id: '12',
    name: 'Veterati',
    organization: 'Veterati',
    description: 'Free mentorship platform connecting veterans with professionals for career guidance and personal development.',
    categories: ['employment'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.veterati.com/',
    phone: null,
    verified: true
  },
  {
    id: '13',
    name: 'Veterans Crisis Line',
    organization: 'VA',
    description: '24/7 crisis support for veterans in crisis or emotional distress. Confidential support by phone, text, or chat.',
    categories: ['mental-health'],
    eligibility: 'All veterans, service members, and their families',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.veteranscrisisline.net/',
    phone: '988 then press 1',
    verified: true
  },
  {
    id: '14',
    name: 'Goodwill Veterans Services',
    organization: 'Goodwill Industries',
    description: 'Job training, employment placement, and career counseling specifically designed for veterans.',
    categories: ['employment'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.goodwill.org/jobs-training/find-a-job/goodwill-veteran-services/',
    phone: null,
    verified: true
  },
  {
    id: '15',
    name: 'Veterans Moving Forward',
    organization: 'Veterans Moving Forward',
    description: 'Free cognitive rehabilitation therapy for veterans with TBI and PTSD. Evidence-based treatment.',
    categories: ['mental-health', 'healthcare'],
    eligibility: 'Veterans with TBI or PTSD',
    tiers: ['green', 'yellow'],
    url: 'https://veteransmovingforward.org/',
    phone: null,
    verified: true
  },
  {
    id: '16',
    name: 'National Veterans Legal Services Program',
    organization: 'NVLSP',
    description: 'Free legal representation for veterans seeking discharge upgrades or appealing VA benefits decisions.',
    categories: ['legal'],
    eligibility: 'Low-income veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.nvlsp.org/',
    phone: '(202) 265-8305',
    verified: true
  },
  {
    id: '17',
    name: 'Bunker Labs',
    organization: 'Bunker Labs',
    description: 'Entrepreneurship program helping veterans start and grow their own businesses with training and mentorship.',
    categories: ['employment'],
    eligibility: 'Military veterans and spouses interested in entrepreneurship',
    tiers: ['green', 'yellow'],
    url: 'https://bunkerlabs.org/',
    phone: null,
    verified: true
  },
  {
    id: '18',
    name: 'Stand Down Events',
    organization: 'National Coalition for Homeless Veterans',
    description: 'Community events providing homeless veterans with food, clothing, health screenings, and housing referrals.',
    categories: ['housing', 'healthcare'],
    eligibility: 'Homeless or at-risk veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://nchv.org/stand-down/',
    phone: '(800) VET-HELP',
    verified: true
  },
  {
    id: '19',
    name: 'Vet Center Readjustment Counseling',
    organization: 'VA',
    description: 'Free confidential counseling for combat veterans and families. Available regardless of discharge status in many cases.',
    categories: ['mental-health'],
    eligibility: 'Combat veterans and their families',
    tiers: ['green', 'yellow'],
    url: 'https://www.va.gov/find-locations/?facilityType=vet_center',
    phone: '(877) 927-8387',
    verified: true
  },
  {
    id: '20',
    name: 'U.S.VETS',
    organization: 'U.S.VETS',
    description: 'Comprehensive services for homeless veterans including housing, case management, employment, and health care.',
    categories: ['housing', 'employment', 'healthcare'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.usvetsinc.org/',
    phone: '(800) 838-4357',
    verified: true
  },
  {
    id: '21',
    name: 'Easter Seals Veterans Services',
    organization: 'Easterseals',
    description: 'Employment, training, and support services for veterans with disabilities.',
    categories: ['employment', 'healthcare'],
    eligibility: 'Veterans with disabilities',
    tiers: ['green', 'yellow'],
    url: 'https://www.easterseals.com/our-programs/veterans/',
    phone: null,
    verified: true
  },
  {
    id: '22',
    name: 'Helmets to Hardhats',
    organization: 'Helmets to Hardhats',
    description: 'Connects veterans with union training programs in building and construction trades. Free apprenticeships.',
    categories: ['employment', 'education'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow'],
    url: 'https://www.helmetstohardhats.org/',
    phone: '(866) 741-6210',
    verified: true
  },
  {
    id: '23',
    name: 'Team Rubicon',
    organization: 'Team Rubicon',
    description: 'Volunteer disaster response for veterans. Provides sense of purpose, community, and identity.',
    categories: ['employment'],
    eligibility: 'All veterans',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://teamrubiconusa.org/',
    phone: null,
    verified: true
  },
  {
    id: '24',
    name: 'Wounded Warrior Project Mental Health',
    organization: 'Wounded Warrior Project',
    description: 'Mental health support including outdoor experiences, peer groups, and connection to resources.',
    categories: ['mental-health'],
    eligibility: 'Post-9/11 veterans',
    tiers: ['green', 'yellow'],
    url: 'https://www.woundedwarriorproject.org/programs/mental-wellness',
    phone: '(888) 997-2586',
    verified: true
  },
  {
    id: '25',
    name: 'Community Tax Law Project - Discharge Upgrades',
    organization: 'Community Tax Law Project',
    description: 'Free legal services for discharge upgrade applications. Serves veterans nationwide via remote consultations.',
    categories: ['legal'],
    eligibility: 'Veterans seeking discharge upgrades',
    tiers: ['green', 'yellow', 'blue'],
    url: 'https://www.ctlp.org/',
    phone: '(804) 782-9430',
    verified: true
  }
];
